import React, { useContext } from 'react';
import { faEdit } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ThemeContext } from 'styled-components';

export interface IDarkFaEditProps {
  'data-test-id'?: string;
}

export const DarkFaEdit: React.FC<IDarkFaEditProps> = (props) => {
  const themeContext = useContext(ThemeContext);
  return <FontAwesomeIcon icon={faEdit} color={themeContext.colors.black} data-test-id={props['data-test-id']} />;
};
